import React, { useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { cn } from '~/lib/utils'
import { useToast } from '~/lib/ui/toast'
import { useTranslation } from '~/hooks/useTranslation'

const Dropzone = ({ className, acceptedFile, setAcceptedFile }) => {
  const { t } = useTranslation('DropzoneResumeUpload')
  const [isDraggingOver, setIsDraggingOver] = useState(false)
  const { toast } = useToast()

  const onDropAccepted = (incomingFiles) => {
    setAcceptedFile(incomingFiles[0])
  }

  const onDropRejected = (incomingFiles) => {
    const {
      file: { type },
      errors,
    } = incomingFiles[0]

    const description = errors.map((e) => ` • ${e.message}`).join('\n')
    if (type) {
      toast({
        description,
        title: t('could_not_upload'),
        variant: 'destructive',
        duration: 10_000,
      })
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: {
      '*/*/pdf': ['.pdf'],
      '*/*/msword': ['.doc'],
      '*/*/document': ['.docx'],
    },
    onDropAccepted,
    onDropRejected,
    onDragEnter: () => setIsDraggingOver(true),
    onDragLeave: () => setIsDraggingOver(false),
    onDrop: () => setIsDraggingOver(false),
    maxSize: 15_000_000, // 15MB
  })

  const baseRootClassName = cn(
    'min-h-[15rem] p-4 border-dashed border text-center content-center justify-items-center',
    className,
  )
  const rootClassName = isDraggingOver
    ? baseRootClassName + ' border-primary border-2 bg-lily-blue'
    : baseRootClassName

  return (
    <div
      {...getRootProps({
        className: rootClassName,
      })}
    >
      <input {...getInputProps()} />
      <div>
        {acceptedFile && (
          <div className="mb-2">
            {acceptedFile.name} - {acceptedFile.size} bytes
          </div>
        )}
        <p>{t('drag_and_drop')}</p>
        <em>{t('file_invalid_type')}</em>
      </div>
    </div>
  )
}
export default Dropzone
